import React, { useState, useEffect } from 'react';
import './ProgressBar.css';

const ProgressBar = ({ isLoading = false }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval;

    if (isLoading) {
      interval = setInterval(() => {
        setProgress((prev) => (prev < 100 ? prev + 2 : 100));
      }, 100);
    } else {
      setProgress(100);
      setTimeout(() => setProgress(0), 500);
    }

    return () => clearInterval(interval);
  }, [isLoading]);

  return (
    <div className={`progress-bar-container ${isLoading ? 'active' : ''}`}>
      <div className="progress-bar" style={{ width: `${progress}%` }}></div>
    </div>
  );
};

export default ProgressBar;
